import { AioReplacementList } from "../additional/aioReplacementList";
import { AioReplacement } from "../additional/interface";
import styles from "../aic.module.css";
import { AitRowGroupData } from "./functions/AitRowGroupData";
import { getBaseId } from "./functions/getBaseId";
import {
  AitHeaderGroupData,
  AitLocationBodyRowGroup,
  AitLocationHeader,
  AitRowType,
  SET_REPLACEMENTS,
} from "./functions/interface";
import { trGetPositionFromLocation } from "./functions/trGetPositionFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitRowGroupReplacementsProps {
  location: AitLocationHeader | AitLocationBodyRowGroup;
}

/**
 * Replacement list editor for a row group.
 *
 * @template T - Row group payload type
 * @param props - Component props
 * @param props.location - The header or body row group location
 */
export const AitRowGroupReplacements = <T,>({ location }: AitRowGroupReplacementsProps) => {
  const { state, dispatch } = useTableContext<T>();
  const thisRowGroup: AitHeaderGroupData<T> | AitRowGroupData<T> | undefined =
    state?.processedTableData ? trGetPositionFromLocation(state, location).data : undefined;
  const id = `${getBaseId(location, state?.id)}-replacements`;

  return !state || !thisRowGroup ? null : (
    <div className={styles.aiwBodyRow}>
      <AioReplacementList
        id={id}
        label={"Replacements"}
        replacements={
          thisRowGroup.replacements ??
          // istanbul ignore next
          []
        }
        setReplacements={
          state.editable
            ? (ret) =>
                dispatch({
                  operation: SET_REPLACEMENTS,
                  location,
                  replacements: ret as AioReplacement<T>[],
                })
            : undefined
        }
        externalLists={state.externalLists}
        dontAskSpace={location.tableSection === AitRowType.header}
        dontAskTrail={location.tableSection === AitRowType.header}
        editorProps={state.editorProps}
        level={0}
      />
    </div>
  );
};

AitRowGroupReplacements.displayName = "AitRowGroupReplacements";
